

import React from 'react';
import { Header, ContentHeader } from './../Calculators/Header';
import {Intro, SmallIntro} from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { Button, ButtonLink, RangerInput } from './../Form/index';
import { ClientDetails } from './Panel';
import { NoData, TheHouse } from './TheHouse'
import {config} from "../../config/config";
// import { Summary } from './Summary';

const { colorConfig } = config();

const titleGI = [
  "With the more 2 life **Inheritance Protection**, if your client doesn’t take the full loan amount offered they can get the best of both" +
  "worlds: money to enjoy their retirement and peace of mind that a percentage of their future property value is protected as an inheritance.",

  "Simply add a few details below to see how it could work for your client."
];

export const GuaranteedInheritanceComponent = ({ screen, guaranteedInheritance, onChangeInput }) => {
  const { input, output } = guaranteedInheritance;
  const maxPrice = 2.25 * input.housePrice;
  const contentHeight = 500 + 53;
  return (
    <div>
      {/*<h1 style={{textAlign: 'center', color: '#0a2f70'}}>Inheritance protection tool</h1>*/}
      {/*<Intro title={'Complete the fields below to visualise how our inheritance protection feature works.'} padding={20} />*/}

      <OneColumnLayout>
        <div className="sidebar">
          <ClientDetails {...guaranteedInheritance} onChangeInput={onChangeInput} />
        </div>
        <div className="content" style={{ height: contentHeight, background: 'transparent' }}>
          <ContentHeader color='#0a2f70'>
            <div className="label" style={{ flex: 1 }}>Now</div>
          </ContentHeader>

          {output.amountProtectedAtStart > 0 ? (
            <TheHouse
              contentHeight={contentHeight}
              color='#177cb0'
              styling='diamond'
              max={maxPrice}
              price={input.housePrice}
              protectedAmount={output.amountProtectedAtStart}
            />
          ) : <NoData />}

        </div>
        <div style={{ width: 20 }}>&nbsp;</div>
        <div className="content" style={{ height: 500 + 53, background: 'transparent' }}>
          <div className="label" style={{flex: 1, fontSize: 12, marginTop: 10, marginBottom: -20, textAlign: 'center', backgroundColor: "#121f45", borderRadius: 5, color: 'white', padding: 12}}>
            See how the value of the percentage protected could change with house price changes over time, using the sliders below:
          </div>
          <ContentHeader color="#121f45">
            <div className="label">Year</div>
            <div style={{ flex: 1, marginTop: 7, paddingLeft: 20, paddingRight: 10 }}>
              <RangerInput
                className="hl"
                value={input.years} min={1} max={15}
                color='#0a2f70' inactiveColor='#f1f9ff' withLabel={true} suffix={''}
                onChange={val => { onChangeInput('years', val) }}
              />
            </div>
            <div className="gap"></div>
          </ContentHeader>

          <div style={{background: '#f5f5f5', display: 'flex', flex: 1, flexDirection: 'row', padding: 12, paddingTop: 8, borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
            <div className="label" style={{flex: 1}}>
              Annual % house price change
            </div>
            <div style={{ paddingLeft:16, paddingRight: 16, flex: 1, alignItems: 'flex-end'}}>
              <RangerInput
                className="ranger"
                style={{ width: 120 }}
                value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'
                color={colorConfig.main} inactiveColor='#bbbbbb' withLabel={true} suffix="%"
                onChange={val => { onChangeInput('futureHousePricePct', val) }}
              />
            </div>
          </div>

          {output.amountProtected > 0 ? (
            <TheHouse
              contentHeight={contentHeight - 113}
              color="#121f45"
              styling='black'
              max={maxPrice}
              price={output.futureHousePrice}
              protectedAmount={output.amountProtected}
            />
          ) : <NoData />}

        </div>

      </OneColumnLayout>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/'>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
        </ButtonPanel>
      )}
    </div>
  );
};

/*
  <div className="content">
    <Summary {...guaranteedInheritance} />
    <HousePriceChange {...guaranteedInheritance} onChangeInput={onChangeInput} />
  </div>
*/



// WEBPACK FOOTER //
// ./src/components/GuaranteedInheritance/GuaranteedInheritanceComponent.js